// Foundations
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
import { InterviewRequestService } from 'src/app/services/interview-request.service';
import { MyProfileService } from 'src/app/services/my-profile.service';

@Component({
  selector: 'app-interview-request-submitted',
  templateUrl: './interview-request-submitted.component.html',
  styleUrls: ['./interview-request-submitted.component.scss'],
})
export class InterviewRequestSubmittedComponent implements OnInit {
  @Input() showCamperApplication: true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public interviewRequestService: InterviewRequestService,
    private _analytics: AnalyticsService,
    public mpService: MyProfileService
  ) {}

  ngOnInit(): void {}

  navigateToLandingPage(): void {
    this._analytics.logButtonTap('interviewRequest_returnToLanding');
    this.router.navigate(['../landing-page'], { relativeTo: this.route });
  }
}
